/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

/**
 * FilterOptionsService - Details page specific filter options API
 *
 * NOTE: This service is currently unused but may be needed when details page
 * filtering becomes more complex. Manual caching has been removed in favor
 * of React Query's built-in caching capabilities.
 *
 * For new implementations, prefer using React Query directly in hooks:
 * - Better caching with stale-while-revalidate
 * - Automatic background updates and error handling
 * - Consistent patterns with other hooks (useRules, etc.)
 */

import HttpServiceSingleton from '../HttpService/HttpService';

const API_BASE = process.env.REACT_APP_RULES_API ?? '';

export interface FilterOptionsData {
  entitlementValueNames: string[];
  endpointNames: string[];
  entitlementTypes: string[];
}

export interface FilterOptionsResponse {
  success: boolean;
  message: string;
  data: FilterOptionsData;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class FilterOptionsService {
  static async getFilterOptions(): Promise<FilterOptionsData> {
    const response = await HttpServiceSingleton.get(
      `${API_BASE}/ECMv6/api/intelligence/ruleRecommendations/rules/filter-options`
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Failed to fetch filter options');
  }
}

export default FilterOptionsService;
